//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  data () {
    return {
      optionSelected: null,
      biomarkerSelected: null,
      accordionStatus: {},
      collectionType: {
        prick: 'blood',
        saliva: 'saliva'
      }
    }
  },
  computed: {
    ...mapState('product', ['baseCompleteTests']),
    optionTitle () {
      return this.optionSelected !== null
        ? this.baseCompleteTests[this.optionSelected].testTitle
        : ''
    },
    optionOverview () {
      return this.optionSelected !== null
        ? this.baseCompleteTests[this.optionSelected].descriptionForGoal
        : ''
    },
    optionDescription () {
      return this.optionSelected !== null
        ? this.baseCompleteTests[this.optionSelected].descriptionForGoal
        : ''
    },
    biomarkers () {
      return this.optionSelected !== null
        ? [...this.baseCompleteTests[this.optionSelected].test.biomarkersTested]
        : []
    },
    filteredBiomarkers () {
      const biomarkers = this.optionSelected !== null
        ? [...this.baseCompleteTests[this.optionSelected].test.biomarkersTested]
        : []
      return biomarkers.filter(biomarker => this.biomarkerSelected ? biomarker !== this.biomarkerSelected : biomarker !== this.biomarkerVModel)
    },
    biomarkerVModel: {
      get () {
        return (this.optionSelected !== null) ? this.baseCompleteTests[this.optionSelected].test.biomarkersTested[0] : {}
      },
      set (newValue) {
        this.biomarkerSelected = newValue
      }
    },
    dropdownText () {
      return this.biomarkerSelected ? this.biomarkerSelected.readableName : this.biomarkerVModel.readableName
    },
    biomarkerDescription () {
      return this.biomarkerSelected ? this.biomarkerSelected.description : this.biomarkerVModel.description
    }
  },
  methods: {
    selectOption (i) {
      if (this.optionSelected === i) {
        this.biomarkerSelected = null
        this.optionSelected = null
      } else {
        this.optionSelected = i
        this.biomarkerSelected = null
      }
    }
  }
}
